module.exports = __webpack_public_path__ + "img/py_list_qwfb_disseleted.3e5a55e1.png";